import { render, staticRenderFns } from "./ListShelter.vue?vue&type=template&id=32838e98&"
import script from "./ListShelter.vue?vue&type=script&lang=js&"
export * from "./ListShelter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports